import { render, staticRenderFns } from "./addOrderDetail.vue?vue&type=template&id=48a1fa3a"
import script from "./addOrderDetail.vue?vue&type=script&lang=js"
export * from "./addOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./addOrderDetail.vue?vue&type=style&index=0&id=48a1fa3a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports